import { TEvent } from 'types/event';
import { EventParams, EventTimelineParams } from 'types/getParams';

import { CRMAPIBase } from '@api/crmApiBase';
import { EventFilterListResp } from '@api/responseModels/event/eventFilterListResp';
import { EventListResp } from '@api/responseModels/event/eventListResponse';
import { EventResp } from '@api/responseModels/event/eventResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class EventGroup extends CRMAPIBase {
    async getEventList(params: EventParams): Promise<RequestResult<EventListResp>> {
        const result = await this.get<EventListResp>(`/events`, {
            ...params,
            per_page: 10,
        });
        return result;
    }

    async getEvent(id: number): Promise<RequestResult<EventResp>> {
        const result = await this.get<EventResp>(`/events/${id}`);
        return result;
    }

    async createEvent(event: TEvent): Promise<RequestResult<EventResp>> {
        const result = await this.post<EventResp>(`/events`, event);
        return result;
    }

    async updateEvent(event: TEvent): Promise<RequestResult<EventResp>> {
        const result = await this.put<EventResp>(`/events/${event.id}`, event);
        return result;
    }

    async deleteEvent(id: number): Promise<RequestResult<EventResp>> {
        const result = await this.delete<EventResp>(`/events/${id}`);
        return result;
    }

    async getEventTimeline(params: EventTimelineParams): Promise<RequestResult<EventListResp>> {
        const result = await this.get<EventListResp>(`/events/timeline`, params);
        return result;
    }

    async getEventStatusList(crm_id: number): Promise<RequestResult<EventFilterListResp>> {
        const result = await this.get<EventFilterListResp>(`/event-statuses`, { crm_id: crm_id });
        return result;
    }

    async getEventTypeList(crm_id: number): Promise<RequestResult<EventFilterListResp>> {
        const result = await this.get<EventFilterListResp>(`/event-types`, { crm_id: crm_id });
        return result;
    }

    async getEventChapterList(crm_id: number): Promise<RequestResult<EventFilterListResp>> {
        const result = await this.get<EventFilterListResp>(`/event-chapter`, { crm_id: crm_id });
        return result;
    }
}

export { EventGroup };
